"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var faSpinnerThird_1 = require("@fortawesome/pro-light-svg-icons/faSpinnerThird");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function SpinnerIcon(_a) {
    var className = _a.className;
    return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faSpinnerThird_1.faSpinnerThird, spin: true, className: className });
}
exports.default = SpinnerIcon;
